var VueScrollTo = require("vue-scrollto");
import moment from "moment-timezone";
export default {
    methods: {
        scrollTo(selector, time = 450) {
            let el = document.getElementById(selector);
            var offset = -125;
            if (!this.isMobileDevice()) {
                offset = -500;
            }
            if (el) {
                var options = {
                    easing: "ease-in",
                    lazy: false,
                    offset: offset,
                    force: true,
                    cancelable: true,
                    onStart: function (element) {
                        // scrolling started
                    },
                    onDone: function (element) {},
                    onCancel: function () {
                        // scrolling has been interrupted
                    },
                    x: false,
                    y: true,
                };
                VueScrollTo.scrollTo(el, time, options);
                this.setSelectedMenuItemId(null);
            }
        },
        handleCategorySort: function (evt) {
            this.setAppProcessing(true);
            let categories = _.map(this.menu.categories, function (object) {
                return _.pick(object, ["id"]);
            });

            axios
                .post(
                    "/api/" +
                        this.$route.params.userSlug +
                        "/menu/categories/" +
                        evt.item.dataset.slug +
                        "/sort-order",
                    {
                        categories: categories,
                        _method: "PATCH",
                    }
                )
                .then(
                    (response) => {
                        this.error = null;
                        this.refreshMenu(this.$route.params.userSlug).then(
                            (result) => {
                                this.setAppProcessing(false);

                                let notification = {
                                    value: true,
                                    type: 1,
                                    message: "Menu Categories Updated",
                                };

                                this.displayNotification(notification);
                            }
                        );
                    },
                    (error) => {
                        this.processing = false;
                        this.error = error;
                    }
                );
        },
        updateDineInIntent: function (intent) {
            this.dineInIntent = intent;
        },
    },
    computed: {
        menuHasItems: function () {
            let hasItems = false;
            if (this.rawMenu.categories) {
                _.forEach(this.rawMenu.categories, function (cValue, cKey) {
                    if (cValue.items.length > 0) {
                        hasItems = true;
                        return;
                    }
                });
            }

            return hasItems;
        },
        menuHasAtLeastOneFilter: function () {
            let hasAFilter = false;
            _.forEach(this.filters, function (fValue, fKey) {
                if (fValue.exists) {
                    hasAFilter = true;
                }
            });
            return hasAFilter;
        },
        //not in use maybe useful?
        menuHasAtLeastOneFilterSelected: function () {
            let hasSelected = false;
            _.forEach(this.filters, function (fValue, fKey) {
                if (fValue.selected) {
                    hasSelected = true;
                    return;
                }
            });
            return hasSelected;
        },
        isMenuOwner: function () {
            if (
                this.user.id &&
                this.rawMenu &&
                this.rawMenu.id &&
                this.user.id == this.rawMenu.user.id
            ) {
                return true;
            }
            return false;
        },
        onlineMenuEnabled: function () {
            if (
                this.rawMenu.user.stripe_charges_enabled &&
                this.rawMenu.user.enable_online_store
            ) {
                if (this.rawMenu.user.online_store_hours) {
                    var nwdate = moment.tz(
                        moment(),
                        this.rawMenu.user.timezone.name
                    );
                    let tf = moment.tz(
                        nwdate,
                        "YYYY-MM-DD HH:mm:ss",
                        this.rawMenu.user.timezone.name
                    );
                    let day = tf.format("dddd").toLowerCase();

                    let dayObject = JSON.parse(
                        this.rawMenu.user.online_store_hours
                    )[day];

                    //toggle  is closed
                    if (!dayObject[0].isOpen) {
                        return false;
                    }

                    //if they havent entered a time
                    if (!dayObject[0].open || !dayObject[0].close) {
                        return true;
                    }

                    //24hrs
                    if (dayObject[0].open == "24hrs") {
                        return true;
                    }

                    let o = moment(dayObject[0].open.toString(), "LT").format(
                        "HH:mm"
                    );

                    let c = moment(dayObject[0].close.toString(), "LT").format(
                        "HH:mm"
                    );

                    let openTime = moment(o, "HH:mm").day(day);
                    let closeTime = moment(c, "HH:mm").day(day);

                    if (openTime.isValid() && closeTime.isValid()) {
                        if (nwdate.isBetween(openTime, closeTime)) {
                            return true;
                        }
                    }
                    return false;
                }

                return true;
            }
            return false;
        },
        userColors() {
            if (this.rawMenu) {
                if (this.rawMenu.user.menu_highlight_color) {
                    return {
                        "--user-highlight-color":
                            this.rawMenu.user.menu_highlight_color,
                    };
                } else {
                    return {
                        "--user-highlight-color": this.primaryColor,
                    };
                }
            } else {
                return {
                    "--user-highlight-color": this.primaryColor,
                };
            }
        },
    },
};
